/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react";
import $ from "jquery";
import DashboardLayout from "../../../shared/DashboardLayout";
import DashboardCard from "../../../shared/DashboardCard";

const Dashboard = () => {
  useEffect(() => {
    $(".toggle_plus_1").click(function () {
      $(".toggle_card_1").slideToggle();
    });
    $(".toggle_plus_2").click(function () {
      $(".toggle_card_2").slideToggle();
    });
    $(".toggle_plus_3").click(function () {
      $(".toggle_card_3").slideToggle();
    });
    $(".toggle_plus_4").click(function () {
      $(".toggle_card_4").slideToggle();
    });
    $(".toggle_plus_5").click(function () {
      $(".toggle_card_5").slideToggle();
    });
    $(".toggle_plus_6").click(function () {
      $(".toggle_card_6").slideToggle();
    });
    $(".toggle_plus_7").click(function () {
      $(".toggle_card_7").slideToggle();
    });
    $(".toggle_plus_8").click(function () {
      $(".toggle_card_8").slideToggle();
    });
    $(".toggle_plus_9").click(function () {
      $(".toggle_card_9").slideToggle();
    });
    $(".toggle_plus_10").click(function () {
      $(".toggle_card_10").slideToggle();
    });
    $(".toggle_plus_11").click(function () {
      $(".toggle_card_11").slideToggle();
    });
    $(".toggle_plus_12").click(function () {
      $(".toggle_card_12").slideToggle();
    });
  });

  return (
    <DashboardLayout>
      <form action="" method="get" className="mx-4" autocomplete="off">
        <h2 className="my-4">
          Dashboard
          <a
            href="#"
            className="btn btn-outline-primary mx-3"
            onclick="window.print()"
          >
            Print
          </a>
          <span
            className=""
            style={{
              display: "inline-block",
              float: "right",
              fontSize: "14px",
            }}
          >
            Items Per Page
            <input
              type="number"
              name="items_per_page"
              value="20"
              style={{ width: "100px" }}
              disabled="disabled"
            />
          </span>
        </h2>

        <div className="clearboth"></div>

        <div className="dashboard">
          <div className="container-dashboard">
            <div className="row">
              {/* <!-- Summary of Today --> */}
              <div className="col-md-4">
                <DashboardCard
                  bgColor="success"
                  title="Summary of Today"
                  link="today_summary"
                  toggleClass="1"
                >
                  <p>
                    <strong>Amount Received:</strong> &nbsp; Rs.{" "}
                  </p>
                  <div id="today_summary" className="toggle_card_1">
                    <p>
                      <strong>Expenses:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p className="mb-0">
                      <strong>P/LS:</strong> &nbsp; Rs.{" "}
                    </p>
                    <hr />
                    <p>
                      <strong>Cash:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p>
                      <strong>Bank:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p className="mb-0">
                      <strong>Others:</strong> &nbsp; Rs.{" "}
                    </p>
                    <hr />
                    <p className="mb-0">
                      <strong>Return:</strong> &nbsp; Rs.{" "}
                    </p>
                    <hr />
                    <p>
                      <strong>Converted:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p className="mb-0">
                      <strong>Formal Converted Return:</strong> &nbsp; Rs. 0
                    </p>
                  </div>
                </DashboardCard>
              </div>

              {/* <!-- Summary of Current Month--> */}
              <div className="col-md-4">
                <DashboardCard
                  bgColor="success"
                  title="Summary of"
                  link="this_month_summary"
                  toggleClass="7"
                >
                  <p>
                    <strong>Amount Received:</strong> &nbsp; Rs.{" "}
                  </p>
                  <div id="this_month_summary" className="toggle_card_7">
                    <p>
                      <strong>Expenses:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p className="mb-0">
                      <strong>P/LS:</strong> &nbsp; Rs.{" "}
                    </p>
                    <hr />
                    <p>
                      <strong>Cash:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p>
                      <strong>Bank:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p>
                      <strong>Others:</strong> &nbsp; Rs.{" "}
                    </p>
                    <hr />
                    <p>
                      <strong>Return:</strong> &nbsp; Rs.{" "}
                    </p>
                    <hr />
                    <p>
                      <strong>Converted:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p className="mb-0">
                      <strong>Formal Converted Return:</strong> &nbsp; Rs. 0
                    </p>
                  </div>
                </DashboardCard>
              </div>

              {/* <!-- Total Houses SUMMMARY --> */}
              <div className="col-md-4">
                <DashboardCard
                  bgColor="success"
                  title="Total Houses Summary"
                  link="total_houses_summary"
                  toggleClass="3"
                >
                  <p className="mb-0">
                    <strong>Houses:</strong> &nbsp;{" "}
                  </p>
                  <div id="total_houses_summary" className="toggle_card_3">
                    <hr />
                    <p>
                      <strong>1 Marla:</strong> &nbsp;
                    </p>
                    <p>
                      <strong>1.5 Marla:</strong> &nbsp;
                    </p>
                    <p>
                      <strong>2 Marla:</strong> &nbsp;
                    </p>
                    <p>
                      <strong>2.5 Marla:</strong> &nbsp;
                    </p>
                    <p className="mb-0">
                      <strong>3 Marla:</strong> &nbsp;
                    </p>
                    <hr />
                    <p>
                      <strong>Total Marlay:</strong> &nbsp;
                    </p>
                    <p>
                      <strong>Available Marlay:</strong> &nbsp;521.9
                    </p>
                    <p className="mb-0">
                      <strong>Balance:</strong> &nbsp;-996{" "}
                    </p>
                  </div>
                </DashboardCard>
              </div>

              {/* <!-- Total SUMMMARY --> */}
              <div className="col-md-4">
                <DashboardCard
                  bgColor="success"
                  title="Total Summary"
                  link="total_summary"
                  toggleClass="2"
                >
                  <p>
                    <strong>Amount Received:</strong> &nbsp; Rs.{" "}
                  </p>
                  <div id="total_summary" className="toggle_card_2">
                    <p>
                      <strong>Expenses:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p className="mb-0">
                      <strong>P/LS:</strong> &nbsp; Rs.{" "}
                    </p>
                    <hr />
                    <p>
                      <strong>Down payment:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p>
                      <strong>Front:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p>
                      <strong>Monthly:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p>
                      <strong>Possesion:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p>
                      <strong>Registery:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p>
                      <strong>Yearly:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p className="mb-0">
                      <strong>Other:</strong> &nbsp;{" "}
                    </p>
                  </div>
                </DashboardCard>
              </div>

              <div className="col-md-4">
                {/* <!-- CA Expenses Summary--> */}
                <DashboardCard
                  bgColor="info"
                  title="CA Expenses Summary"
                  link="ca_expenses_summary"
                  toggleClass="4"
                >
                  <p className="mb-0">
                    <strong>Balance:</strong> &nbsp; Rs.{" "}
                  </p>
                  <div id="ca_expenses_summary" className="toggle_card_4">
                    <hr />
                    <p>
                      <strong>Amount Given:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p className="mb-0">
                      <strong>Amount Spent:</strong> &nbsp; Rs.{" "}
                    </p>
                  </div>
                </DashboardCard>

                {/* <!-- Summary of Payment Source --> */}
                <DashboardCard
                  bgColor="primary"
                  title="Payment Source"
                  link="payment_source_summary"
                  toggleClass="5"
                >
                  <p className="mb-0">
                    <strong>Amount Received:</strong> &nbsp; Rs.{" "}
                  </p>
                  <div id="payment_source_summary" className="toggle_card_5">
                    <hr />
                    <p>
                      <strong>Cash:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p>
                      <strong>Bank:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p className="mb-0">
                      <strong>Others:</strong> &nbsp;{" "}
                    </p>
                  </div>
                </DashboardCard>
              </div>

              <div className="col-md-4">
                {/* <!-- Project Expenses --> */}
                <DashboardCard
                  bgColor="info"
                  title="Project Expenses"
                  link="all_project_expenses"
                  toggleClass="8"
                >
                  <p className="mb-0">
                    <strong>Total:</strong> &nbsp; Rs.{" "}
                  </p>
                  <div id="all_project_expenses" className="toggle_card_8">
                    <hr />
                    <p>
                      <strong>A Block:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p>
                      <strong>B Block:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p>
                      <strong>C Block:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p>
                      <strong>D Block:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p>
                      <strong>E Block:</strong> &nbsp; Rs.{" "}
                    </p>
                  </div>
                </DashboardCard>

                {/* <!-- Users Last Login Stats --> */}
                <DashboardCard
                  textColor="black"
                  title="Users Last Login Stats"
                  link="user_login_stats"
                  toggleClass="9"
                >
                  <div id="user_login_stats" className="toggle_card_9">
                    <table className="table">
                      <tbody>
                        <tr>
                          <td>Name</td>
                          <td>Time</td>
                        </tr>
                        <tr>
                          <td className="text-capitalize"></td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </DashboardCard>
              </div>

              {/* <!-- Summary of A Block --> */}
              <div className="col-md-4">
                <DashboardCard
                  bgColor="primary"
                  title="Summary of A Block"
                  link="ablock_summary"
                  toggleClass="10"
                >
                  <p className="mb-0">
                    <strong>P/LS:</strong> &nbsp; Rs. 1,195,630
                  </p>
                  <div id="ablock_summary" className="toggle_card_10">
                    <hr />
                    <p>
                      <strong>Total Marlay:</strong>{" "}
                    </p>
                    <p>
                      <strong>Total Houses:</strong>{" "}
                    </p>
                    <p>
                      <strong>Total Worth:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p className="mb-0">
                      <strong>Total Expense:</strong> &nbsp; Rs.{" "}
                    </p>
                  </div>
                </DashboardCard>
              </div>

              {/* <!-- Summary of B Block --> */}
              <div className="col-md-4">
                <DashboardCard
                  bgColor="primary"
                  title="Summary of B Block"
                  link="bblock_summary"
                  toggleClass="11"
                >
                  <p className="mb-0">
                    <strong>P/LS:</strong> &nbsp; Rs. 1,195,630
                  </p>
                  <div id="bblock_summary" className="toggle_card_11">
                    <hr />
                    <p>
                      <strong>Total Marlay:</strong>{" "}
                    </p>
                    <p>
                      <strong>Total Houses:</strong>{" "}
                    </p>
                    <p>
                      <strong>Total Worth:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p className="mb-0">
                      <strong>Total Expense:</strong> &nbsp; Rs.{" "}
                    </p>
                  </div>
                </DashboardCard>
              </div>

              {/* <!-- Summary of C Block --> */}
              <div className="col-md-4">
                <DashboardCard
                  bgColor="primary"
                  title="Summary of C Block"
                  link="cblock_summary"
                  toggleClass="12"
                >
                  <p className="mb-0">
                    <strong>P/LS:</strong> &nbsp; Rs. 1,195,630
                  </p>
                  <div id="cblock_summary" className="toggle_card_12">
                    <hr />
                    <p>
                      <strong>Total Marlay:</strong>{" "}
                    </p>
                    <p>
                      <strong>Total Houses:</strong>{" "}
                    </p>
                    <p>
                      <strong>Total Worth:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p className="mb-0">
                      <strong>Total Expense:</strong> &nbsp; Rs.{" "}
                    </p>
                  </div>
                </DashboardCard>
              </div>

              {/* <!-- Return Sumary--> */}
              <div className="col-md-4">
                <DashboardCard
                  bgColor="danger"
                  title="Return Summary"
                  link="return_summary"
                  toggleClass="6"
                >
                  <p className="mb-0">
                    <strong>Balance:</strong> &nbsp; Rs.{" "}
                  </p>
                  <div id="return_summary" className="toggle_card_6">
                    <hr />
                    <p>
                      <strong>Should Return:</strong> &nbsp; Rs.{" "}
                    </p>
                    <p className="mb-0">
                      <strong>Amount Returned:</strong> &nbsp; Rs.{" "}
                    </p>
                  </div>
                </DashboardCard>
              </div>
            </div>
          </div>
        </div>

        <h2 className="my-5">
          <span>Date Interval Report</span>
        </h2>

        <div className="row">
          <div className="col-lg-2">
            <label for="year" className=" fw-bolder">
              Start Date:
            </label>
          </div>
          <div className="col-lg-4 form-group">
            <input
              type="date"
              name="start_date"
              className="form-control"
              value=""
              id="dp1643993091331"
            />
          </div>
          <div className="col-lg-2">
            <label for="year" className=" fw-bolder">
              End Date:
            </label>
          </div>
          <div className="col-lg-4 form-group">
            <input
              type="date"
              name="end_date"
              className="form-control"
              value=""
              id="dp1643993091332"
            />
          </div>
          <div className="form-group">
            <input
              type="submit"
              className="btn site_btn text-white"
              name="submit"
              value="Submit"
            />
          </div>
        </div>
      </form>
    </DashboardLayout>
  );
};

export default Dashboard;
